module.exports = {"TXTCLI_Number":{"id":"TXTCLI_Number","defaultMessage":"Αριθμός","track":"Number"}}